export function LockOpenIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect
        x="4.375"
        y="9.375"
        width="11.25"
        height="8.125"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 9.375V6.25C6.875 4.52411 8.27411 3.125 10 3.125C11.7259 3.125 13.125 4.52411 13.125 6.25"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
